import { DragHandle, InfoOutlined, PlayArrow } from "@material-ui/icons";
import {
  Box,
  Card,
  Grid,
  Skeleton,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import { CurrencyDisplay } from "components";
import { globalStyles } from "styles";
import BackgroundBalanceCard from "../../../assets/background/background_balance_card.svg";
import DollarIcon from "../../../assets/image-public/images/icon_images/ri_money-dollar-circle-fill.svg";

const BalanceCard = ({
  title,
  value,
  prefix,
  clientLabel,
  periodLabel,
  minWidth,
  formattedValue,
  backgroundColor,
  infoButton,
  tooltipTitle,
  onClick,
  subTitleJustify,
  subTitle,
  description,
  changeIndicator,
  indicatorColor,
  loading,
  titleColor,
  infoIcon,
  showDollar = true,
}) => {
  const classes = globalStyles();
  return loading ? (
    <SkeletonCard variant="rounded" />
  ) : (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <img
        className={classes?.backgroundBalanceCard}
        src={BackgroundBalanceCard}
        alt="Overlay Design"
      />
      <CustomCard
        minWidth={minWidth}
        backgroundColor={backgroundColor}
        onClick={onClick}
        cursorPointer={onClick}
      >
        <Grid
          container
          alignItems="center"
          columnGap={2}
          mb={(clientLabel || periodLabel) && 1.5}
          mr={periodLabel && "36px"}
        >
          {showDollar && (
            <Grid item>
              <img src={DollarIcon} alt="$" />
            </Grid>
          )}
          <Grid item xs>
            <Grid container direction="column">
              <Grid item>
                <BalanceTitle color={titleColor}>
                  {title || "Balance"}
                </BalanceTitle>
              </Grid>
              <Grid item>
                <BalanceValue>
                  {formattedValue ? (
                    formattedValue
                  ) : (
                    <CurrencyDisplay
                      value={value}
                      decimalScale={2}
                      prefix={`${prefix ? prefix : "Rp"}`}
                    />
                  )}
                </BalanceValue>
              </Grid>
              <Grid item>
                <Grid container columnGap={2} justifyContent={subTitleJustify}>
                  <Grid item>
                    <BalanceTitle color={titleColor}>{subTitle}</BalanceTitle>
                  </Grid>
                  <Grid item>
                    <Grid container>
                      {changeIndicator && (
                        <Grid
                          item
                          height={14}
                          color={
                            indicatorColor ||
                            (changeIndicator === "up"
                              ? "#83CF8F"
                              : changeIndicator === "down"
                              ? "red"
                              : "white")
                          }
                        >
                          {changeIndicator === "up" ||
                          changeIndicator === "down" ? (
                            <PlayArrow
                              className={
                                changeIndicator === "up"
                                  ? classes?.rotate270
                                  : classes?.rotate90
                              }
                            />
                          ) : (
                            <DragHandle />
                          )}
                        </Grid>
                      )}
                      <Grid item>
                        <BalanceTitle color={titleColor}>
                          {description}
                        </BalanceTitle>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {infoButton && (
            <Grid item alignSelf="flex-start" color="white">
              {tooltipTitle ? (
                <Tooltip
                  title={
                    <Typography fontSize={14} color="white">
                      {tooltipTitle}
                    </Typography>
                  }
                  placement="top-end"
                >
                  {infoIcon ? infoIcon : <InfoOutlined />}
                </Tooltip>
              ) : infoIcon ? (
                infoIcon
              ) : (
                <InfoOutlined />
              )}
            </Grid>
          )}
        </Grid>
        <Grid container justifyContent="space-between">
          {clientLabel && (
            <Grid item>
              <BalanceTitle color={titleColor}>{clientLabel}</BalanceTitle>
            </Grid>
          )}
          {periodLabel && (
            <Grid item>
              <BalanceTitle color={titleColor}>{periodLabel}</BalanceTitle>
            </Grid>
          )}
        </Grid>
      </CustomCard>
    </Box>
  );
};

const CustomCard = styled(Card)(
  ({ minWidth, backgroundColor, cursorPointer }) => ({
    backgroundColor: backgroundColor || "#111827",
    cursor: cursorPointer && "pointer",
    minWidth,
    width: "fit-content",
    padding: "16px 24px",
    borderRadius: "10px",
    position: "relative",
    overflow: "hidden",
  })
);
const SkeletonCard = styled(Skeleton)({
  width: 350,
  height: 115,
  borderRadius: 10,
});
const BalanceTitle = styled(Typography)(({ color }) => ({
  fontFamily: "Inter",
  color: color || "#9AA2B1",
  fontSize: 14,
}));
const BalanceValue = styled(Typography)({
  fontFamily: "Inter",
  color: "white",
  fontSize: 18,
  fontWeight: 600,
});

export default BalanceCard;
